import { createSlice } from "@reduxjs/toolkit";

import { ICashDrawerReasonResponse } from "../../typings/interfaces/responses/cash-drawer-reason-response";
import {
    createCashDrawerReasonAction,
    deleteCashDrawerReasonAction,
    getAllCashDrawerReasonsAction,
    updateCashDrawerReasonAction,
} from "../actions/cashDrawerReasonsAction";

export interface CashDrawerReasonState {
    cashDrawerReasons: ICashDrawerReasonResponse[] | null;
    cashDrawerReasonsLoading: boolean;
    cashDrawerReasonsError: string | null;

    addCashDrawerReasonResponse: ICashDrawerReasonResponse | null;
    addCashDrawerReasonLoading: boolean;
    addCashDrawerReasonError: string | null;

    deleteCashDrawerReasonResponse: boolean | null;
    deleteCashDrawerReasonLoading: boolean;
    deleteCashDrawerReasonError: string | null;

    updateCashDrawerReasonResponse: ICashDrawerReasonResponse | null;
    updateCashDrawerReasonLoading: boolean;
    updateCashDrawerReasonError: string | null;
}

const initialState: CashDrawerReasonState = {
    cashDrawerReasons: null,
    cashDrawerReasonsLoading: false,
    cashDrawerReasonsError: null,

    addCashDrawerReasonResponse: null,
    addCashDrawerReasonLoading: false,
    addCashDrawerReasonError: null,

    deleteCashDrawerReasonResponse: null,
    deleteCashDrawerReasonLoading: false,
    deleteCashDrawerReasonError: null,

    updateCashDrawerReasonResponse: null,
    updateCashDrawerReasonLoading: false,
    updateCashDrawerReasonError: null,
};

const cashDrawerReasonsSlice = createSlice({
    name: "cashDrawerReasons",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get All
        builder
            .addCase(getAllCashDrawerReasonsAction.pending, (state) => {
                state.cashDrawerReasons = null;
                state.cashDrawerReasonsLoading = true;
                state.cashDrawerReasonsError = null;
            })
            .addCase(getAllCashDrawerReasonsAction.fulfilled, (state, action) => {
                state.cashDrawerReasonsError = null;
                state.cashDrawerReasonsLoading = false;
                state.cashDrawerReasons = (action.payload as any).body;
            })
            .addCase(getAllCashDrawerReasonsAction.rejected, (state, action) => {
                state.cashDrawerReasons = null;
                state.cashDrawerReasonsLoading = false;
                state.cashDrawerReasonsError = (action.payload as any).message;
            });

        // Create
        builder
            .addCase(createCashDrawerReasonAction.pending, (state) => {
                state.addCashDrawerReasonResponse = null;
                state.addCashDrawerReasonLoading = true;
                state.addCashDrawerReasonError = null;
            })
            .addCase(createCashDrawerReasonAction.fulfilled, (state, action) => {
                state.addCashDrawerReasonResponse = (action.payload as any).body;
                state.addCashDrawerReasonLoading = false;
                state.addCashDrawerReasonError = null;
            })
            .addCase(createCashDrawerReasonAction.rejected, (state, action) => {
                state.addCashDrawerReasonResponse = null;
                state.addCashDrawerReasonLoading = false;
                state.addCashDrawerReasonError = (action.payload as any).message;
            });

        // Delete
        builder
            .addCase(deleteCashDrawerReasonAction.pending, (state) => {
                state.deleteCashDrawerReasonResponse = null;
                state.deleteCashDrawerReasonLoading = true;
                state.deleteCashDrawerReasonError = null;
            })
            .addCase(deleteCashDrawerReasonAction.fulfilled, (state, action) => {
                state.deleteCashDrawerReasonResponse = action.payload;
                state.deleteCashDrawerReasonLoading = false;
                state.deleteCashDrawerReasonError = null;
            })
            .addCase(deleteCashDrawerReasonAction.rejected, (state, action) => {
                state.deleteCashDrawerReasonResponse = null;
                state.deleteCashDrawerReasonLoading = false;
                state.deleteCashDrawerReasonError = (action.payload as any).message;
            });

        // Update
        builder
            .addCase(updateCashDrawerReasonAction.pending, (state) => {
                state.updateCashDrawerReasonResponse = null;
                state.updateCashDrawerReasonLoading = true;
                state.updateCashDrawerReasonError = null;
            })
            .addCase(updateCashDrawerReasonAction.fulfilled, (state, action) => {
                state.updateCashDrawerReasonResponse = action.payload;
                state.updateCashDrawerReasonLoading = false;
                state.updateCashDrawerReasonError = null;
            })
            .addCase(updateCashDrawerReasonAction.rejected, (state, action) => {
                state.updateCashDrawerReasonResponse = null;
                state.updateCashDrawerReasonLoading = false;
                state.updateCashDrawerReasonError = (action.payload as any).message;
            });
    },
});

export default cashDrawerReasonsSlice.reducer;
export const cashDrawerReasonsSliceActions = cashDrawerReasonsSlice.actions;
